import { render, staticRenderFns } from "./image-card.vue?vue&type=template&id=0559e8a7&"
import script from "./image-card.vue?vue&type=script&lang=js&"
export * from "./image-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports